<template>
  <div :class="rootClasses">
    <label v-if="$slots.label" :for="attrs?.inputId as string">
      <slot name="label" />
    </label>

    <PVMultiSelect
      v-model="value"
      v-bind="$attrs"
      @focus="focused = true"
      @blur="focused = false"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
    />

    <span v-if="$slots.helperText" class="caption">
      <slot name="helperText" />
    </span>
  </div>
</template>

<script setup lang="ts">
import PVMultiSelect from 'primevue/multiselect';
import { useAttrs } from 'vue';
import { useInputState } from '../composables';

// TODO: Investigate if we need to inheritAttrs. ATM all of the attrs are duplicated between the root div and the PVMultiSelect component.
// If not, uncomment the following line.
// defineOptions({
//   inheritAttrs: false,
// });

const attrs = useAttrs();

const value = defineModel<any>();

const { focused, hovered, classes: rootClasses } = useInputState(attrs);

defineExpose({
  value,
});
</script>
